import { projectGeodesistsAPI } from "./api";

export const getProjectTypes = async () => {
  return await projectGeodesistsAPI.getProjectTypes();
};

export const getWorkSetCheckGroups = async () => {
  return await projectGeodesistsAPI.getWorkSetCheckGroups();
};

export const getProjectGeodesists = async (params = {}) => {
  const res = await projectGeodesistsAPI.getProjectGeodesists(params);
  return Array.isArray(res) ? res : res?.data ?? [];
};

export const addProjectGeodesist = async (body) => {
  const res = await projectGeodesistsAPI.addProjectGeodesist(body);
  return Array.isArray(res) ? res : res?.data ?? res;
};

export const deleteProjectGeodesist = async (project_geodesist_id, params = {}) => {
  const res = await projectGeodesistsAPI.deleteProjectGeodesist(
    project_geodesist_id,
    params
  );
  return Array.isArray(res) ? res : res?.data ?? res;
};

export const projectGeodesistsColumns = [
  {
    name: "project_type_name",
    field: "project_type_name",
    label: "Тип проекта",
    align: "left",
  },
  {
    name: "work_set_check_group_name",
    field: "work_set_check_group_name",
    label: "Группа работ",
    align: "left",
  },
  {
    name: "actions",
    label: "",
    align: "center",
    field: "actions",
  },
];
